import { render } from "./Approved.vue?vue&type=template&id=c46e1b34&scoped=true&ts=true"
import script from "./Approved.vue?vue&type=script&lang=ts"
export * from "./Approved.vue?vue&type=script&lang=ts"

import "./Approved.vue?vue&type=style&index=0&id=c46e1b34&lang=scss&scoped=true"

import exportComponent from "/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c46e1b34"]])

export default __exports__